module.exports = __webpack_public_path__ + "img/face-2.119d7ee6.jpg";